import { call, put } from 'redux-saga/effects';
import { saveRoleSuccess, saveRoleFailure } from '../slice';
import { PUT, DELETE, getHeaders } from 'src/services/ApiService';

export function* saveRoleSaga(action) {
    const { subId, updatedSubDetails } = action.payload;
    let result;
    if (!updatedSubDetails.connectedAppRoles[0].roleId) {
        result = yield call(DELETE, `/iambff/v1/users/${subId}/app-role-mappings`, getHeaders());
    } else {
        result = yield call(
            PUT,
            `/iambff/v1/users/${subId}/connected-apps/asio_platform/app-role-mappings`,
            getHeaders(),
            updatedSubDetails
        );
    }

    if (result.isSuccess) {
        yield put(
            saveRoleSuccess({
                data: result.response,
            })
        );
    } else {
        yield put(saveRoleFailure(result));
    }
}
